import React from "react";
import { Eye } from "lucide-react";

const labels = {
  NOT_STARTED: "Non commence",
  IN_PROGRESS: "En cours",
  COMPLETED: "Termine",
  FAILED: "Echoue",
};

const formatDate = (value) =>
  value ? new Intl.DateTimeFormat("fr-FR", { dateStyle: "short", timeStyle: "short" }).format(new Date(value)) : "-";

const formatTime = (seconds) => {
  if (!seconds) return "0 min";
  const minutes = Math.floor(seconds / 60);
  return minutes < 60 ? `${minutes} min` : `${Math.floor(minutes / 60)}h ${minutes % 60}min`;
};

const formatScore = (value) => (value == null ? "-" : Math.round(value * 10) / 10);

export default function LmsGlobalReportingTable({ rows, onOpenDetail }) {
  if (!rows?.length) {
    return <div className="lms-report-empty">Aucune progression LMS a afficher.</div>;
  }

  return (
    <div className="lms-report-table-wrap">
      <table className="lms-report-table">
        <thead>
          <tr>
            <th>Collaborateur</th>
            <th>Statut</th>
            <th>Progression</th>
            <th>Score</th>
            <th>Contenus</th>
            <th>Quiz</th>
            <th>Evaluation</th>
            <th>SCORM</th>
            <th>Certificat</th>
            <th>Temps</th>
            <th>Dernier acces</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.userId}>
              <td>
                <strong>{row.fullName || `${row.firstName || ""} ${row.lastName || ""}`}</strong>
                <span>{row.email}</span>
              </td>
              <td>
                <span className={`lms-status lms-status-${String(row.status || "").toLowerCase()}`}>
                  {labels[row.status] || row.status}
                </span>
              </td>
              <td>
                <div className="lms-progress-cell">
                  <div style={{ width: `${Math.max(0, Math.min(row.progressPercent || 0, 100))}%` }} />
                </div>
                <span className="lms-progress-label">{row.progressPercent || 0}%</span>
              </td>
              <td>{formatScore(row.score)}</td>
              <td>{row.completedContentsCount || 0} / {row.totalContentsCount || 0}</td>
              <td>{row.quizPassedCount || 0} / {row.quizTotalCount || 0}</td>
              <td>{row.evaluationSubmittedCount || 0} / {row.evaluationTotalCount || 0}</td>
              <td>{row.scormCompletedCount || 0} / {row.scormTotalCount || 0}</td>
              <td>{row.certificateGenerated ? "Généré" : "Non généré"}</td>
              <td>{formatTime(row.timeSpentSeconds)}</td>
              <td>{formatDate(row.lastAccessAt)}</td>
              <td>
                <button className="lms-icon-button" type="button" onClick={() => onOpenDetail(row.userId)} title="Voir le detail">
                  <Eye size={16} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
